import { useMutation, useQueryClient } from '@tanstack/react-query';

import { restoreExcludedCreatorMutationOptions } from '@/entities/exclude-list';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { trackEvent } from '@/shared/track';

export function useRestoreExcludedCreatorMutation() {
  const queryClient = useQueryClient();
  const { workspaceId } = useWorkspaceId();
  const options = restoreExcludedCreatorMutationOptions(queryClient, workspaceId);

  return useMutation({
    ...options,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await options.onSuccess?.(data, variables, onMutateResult, context);
      trackEvent('Exclude_list', 'remove_exclude', {
        creator_id: data.creator_id,
      });
    },
  });
}
